<template>
    <Dialog :visible="visible" modal :style="{ width: '50rem' }" :closable="false">  
        <template #header>
            <div class="flex justify-content-between w-full">
                <h3>Presenze</h3>
                <Button icon="pi pi-times" @click="closeDialog" class="p-button-text p-button-rounded p-button-secondary"/>
            </div>
        </template>    
        <DataTable :value="localIscritti" tableStyle="min-width: 50rem">
            <Column field="nome" header="Nome">
                <template #body="{ data }">
                        <Button class="p-button-link" @click="goToAtleta(data.id)" >{{ capitalize(data.nome.trim()) }} {{ capitalize(data.cognome.trim()) }}</Button>
                </template>    
            </Column>
            <Column field="presente" header="Presente">
                <template #body="{ data }">
                    <Checkbox :value="data.id" v-model="selectedIscritti[data.id]" :binary="true"/>
                </template>
            </Column>
        </DataTable>
        <template #footer>
            <Button label="Salva" @click="save"/>
        </template>
    </Dialog>
</template>

<script>
import { ref, watch } from 'vue';
import Dialog from 'primevue/dialog';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Checkbox from 'primevue/checkbox';
import Button from 'primevue/button';

export default {
    name: 'DialogComponent',
    components: {
        Dialog,
        DataTable,
        Column,
        Checkbox,
        Button
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        iscritti: {
            type: Array,
            required: true
        }
    },
    methods: {

        capitalize (str){
        if (!str) return '';
        return str
          .toLowerCase()
          .split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
      },
    },
    setup(props, { emit }) {
        const localIscritti = ref([...props.iscritti]);
        const selectedIscritti = ref({});

        watch(() => props.iscritti, (newVal) => {
            localIscritti.value = [...newVal];
            // selectedIscritti.value = newVal.filter(iscritto => iscritto.presente === 1).map(iscritto => iscritto.id);
            newVal.forEach(val => {
                selectedIscritti.value[val.id] = Boolean(val.presente)
            })
        });
       

        const goToAtleta = (idatleta)=> {
            window.open(`/atleta/${idatleta}/dettagli`)
        }
        const closeDialog = () => {
            emit('close');
        };

        const save = () => {
            emit('save', selectedIscritti.value);
            selectedIscritti.value = []
            closeDialog();
        };

        return {
            goToAtleta,
            selectedIscritti,
            localIscritti,
            closeDialog,
            save
        };
    }
};
</script>

<style scoped>
</style>
